import React, { useEffect, useState } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";
export default function CommissionManagerFormModal({ show, onClose, mode, userData, onSuccess }) {
  const [errors, setErrors] = useState({});
  const {userid} = useSession();
  const [dropdowns, setDropdowns] = useState({
    comTypes: [],
    schemes: [],
    operators: [],
    commissionTypes: [],
  });

  // Fetch dropdown data from APIs
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        const apiForm = new FormData();
        apiForm.append("action", "GET");
        apiForm.append("userid", userid);
        const [comTypeRes, schemeRes, operatorRes, comTypeMasterRes] = await Promise.all([
          fetch("https://pro.mokshiq.in/commission_type_manager_action",{
            method: "POST",
             headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
            body: apiForm,
          }),
          fetch("https://pro.mokshiq.in/scheme_manager_action",{
            method: "POST",
             headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
            body: apiForm,
          }),
          fetch("https://pro.mokshiq.in/provider_manager_action",{
            method: "POST",
             headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
            body: apiForm,
          })
        ]);

        const comTypes = await comTypeRes.json();
        const schemes = await schemeRes.json();
        const operators = await operatorRes.json();

        setDropdowns({
          comTypes: comTypes?.data || [],
          schemes: schemes?.data || [],
          operators: operators?.data || []
        });
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
      }
    };

    if (show) fetchDropdowns();
  }, [show]);


  const validateForm = () => {
    const requiredFields = [
      "com_type_id",
      "type",
      "scheme_id",
      "operator_id",
      "white_label",
      "admin",
      "super_distributor",
      "distributor",
      "retailer"
     
    ];
    let newErrors = {};

    requiredFields.forEach((field) => {
      const value = document.querySelector(`[name="${field}"]`)?.value?.trim();
      if (!value) {
        newErrors[field] = `${field.replace("_", " ")} is required.`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const formData = new FormData(document.getElementById("commission-form"));
    formData.append("action", "ADDUpdate");
    formData.append("userid", userid);
    formData.append("id", userData?.id || "");

    try {
      const response = await fetch("https://pro.mokshiq.in/commission_manager_action", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });

      if (!response.ok) {
        showMainToast("Something went wrong!", "danger");
      }

      const result = await response.json();
      if (result.status) {
        showMainToast(result.data || "Success!", "success");
        onClose();
         if (onSuccess) onSuccess();
      } else {
        showMainToast(result.data || "Something went wrong!", "danger");
      }
    } catch (error) {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Commission" : "Add Commission"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control" id="commission-form">
          {/* com_type_id */}
          <div className="col-md-6">
            <label className="form-label">Com Type ID</label>
            <select
              className={`form-select ${errors.com_type_id ? "is-invalid" : ""}`}
              name="com_type_id"
              defaultValue={userData?.com_type_id || ""}
            >
              <option value="">-- Select --</option>
              {dropdowns.comTypes.map((item) => (
                <option key={item.id} value={item.id}>{item.Name}</option>
              ))}
            </select>
            {errors.com_type_id && <div className="text-danger mt-1">{errors.com_type_id}</div>}
          </div>

          {/* type */}
          <div className="col-md-6">
            <label className="form-label">Type</label>
            <select
              className={`form-select ${errors.type ? "is-invalid" : ""}`}
              name="type"
              defaultValue={userData?.type || ""}
            >
              <option value="">-- Select --</option>
              
            
                <option  value="percent">Percent</option>
                <option  value="fixed">Fixed</option>
              
            </select>
            {errors.type && <div className="text-danger mt-1">{errors.type}</div>}
          </div>

          {/* scheme_id */}
          <div className="col-md-6">
            <label className="form-label">Scheme</label>
            <select
              className={`form-select ${errors.scheme_id ? "is-invalid" : ""}`}
              name="scheme_id"
              defaultValue={userData?.scheme_id || ""}
            >
              <option value="">-- Select --</option>
              {dropdowns.schemes.map((item) => (
                <option key={item.id} value={item.id}>{item.Name}</option>
              ))}
            </select>
            {errors.scheme_id && <div className="text-danger mt-1">{errors.scheme_id}</div>}
          </div>

          {/* operator_id */}
          <div className="col-md-6">
            <label className="form-label">Operator</label>
            <select
              className={`form-select ${errors.operator_id ? "is-invalid" : ""}`}
              name="operator_id"
              defaultValue={userData?.operator_id || ""}
            >
              <option value="">-- Select --</option>
              {dropdowns.operators.map((item) => (
                <option key={item.id} value={item.id}>{item.Name}</option>
              ))}
            </select>
            {errors.operator_id && <div className="text-danger mt-1">{errors.operator_id}</div>}
          </div>

          {/* white_label */}
          <div className="col-md-6">
            <label className="form-label">White Label</label>
            <input
              className={`form-control ${errors.white_label ? "is-invalid" : ""}`}
              name="white_label"
              type="number"
              defaultValue={userData?.white_label || ""}
            />
            {errors.white_label && <div className="text-danger mt-1">{errors.white_label}</div>}
          </div>

          {/* admin */}
          <div className="col-md-6">
            <label className="form-label">Admin</label>
            <input
              className={`form-control ${errors.admin ? "is-invalid" : ""}`}
              name="admin"
              type="number"
              defaultValue={userData?.admin || ""}
            />
            {errors.admin && <div className="text-danger mt-1">{errors.admin}</div>}
          </div>

          {/* super_distributor */}
          <div className="col-md-6">
            <label className="form-label">Super Distributor</label>
            <input
              className={`form-control ${errors.super_distributor ? "is-invalid" : ""}`}
              name="super_distributor"
              type="number"
              defaultValue={userData?.super_distributor || ""}
            />
            {errors.super_distributor && <div className="text-danger mt-1">{errors.super_distributor}</div>}
          </div>

          {/* distributor */}
          <div className="col-md-6">
            <label className="form-label">Distributor</label>
            <input
              className={`form-control ${errors.distributor ? "is-invalid" : ""}`}
              name="distributor"
              type="number"
              defaultValue={userData?.distributor || ""}
            />
            {errors.distributor && <div className="text-danger mt-1">{errors.distributor}</div>}
          </div>

          {/* retailer */}
          <div className="col-md-6">
            <label className="form-label">Retailer</label>
            <input
              className={`form-control ${errors.retailer ? "is-invalid" : ""}`}
              name="retailer"
              type="number"
              defaultValue={userData?.retailer || ""}
            />
            {errors.retailer && <div className="text-danger mt-1">{errors.retailer}</div>}
          </div>

          {/* com_type */}
          
        </form>
      </div>
    </BaseModal>
  );
}
